import React, {useEffect} from 'react';

import {Form, Input, Button, Radio, Upload, Checkbox, Row, Col, Typography, Select, DatePicker, Divider, Alert, InputNumber, Card} from 'antd';
import Flex from '../Flex';
const {Text, Title, Paragraph} = Typography;

import {useInput, useNumber} from 'react-hanger';

export interface IUserLoginForm {
  userName: string;
  passwordMd5: string;
}

const UserLoginForm = (props: {isLoading: boolean; onFinish: (value: IUserLoginForm) => any}) => {
  const [form] = Form.useForm();
  const userName = useInput('');
  const passwordMd5 = useInput('');

  return (
    <React.Fragment>
      <Card title={'登录'}>
        <Form labelCol={{span: 6}} wrapperCol={{span: 14}} layout={'horizontal'} form={form} onFinish={value => props.onFinish(value as IUserLoginForm)}>
          <Form.Item label={'用户 ID'} name={'userName'} rules={[{required: true}, {pattern: /^[A-Za-z0-9]{0,20}$/, message: '用户 ID 只能由数字和字母组合'}]}>
            <Input size={'large'} placeholder="请输入用户 ID" />
          </Form.Item>
          <Form.Item label={'密码'} name={'passwordMd5'} rules={[{required: true}]}>
            <Input.Password size={'large'} placeholder="请输入密码" />
          </Form.Item>
          <Row>
            <Col span={6} />
            <Col>
              <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit">
                立即登录
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </React.Fragment>
  );
};

export default UserLoginForm;
